import React, { Component } from 'react'
import { SimpleErrorPage } from '@ynap/error-page'
import BEMHelper from '@ynap/bem-helper'
import { raygun } from '@ynap/clientside-monitoring'

const bem = new BEMHelper('ErrorBountryCatchAll')

export default class ErrorBountryCatchAll extends Component {
    constructor(props) {
        super(props)
        this.state = {
            customerCareNumber: '',
            hasError: false
        }
    }

    static getDerivedStateFromError() {
        const { customerCare: { telephone: customerCareNumber } = {} } = window?.SF?.getContactDetails?.() || {}
        // TODO: See if it is possible to propogate orderID from redux state to display on error
        const fallbackErrorTitle = 'Unfortunately there has been an error'
        // TODO: wrap customerCareNumber in a tag with href to number for mobile users
        const fallbackErrorMessage = `You can complete your order by contacting customer care
                        ${customerCareNumber && ` on ${customerCareNumber}`}`

        return { hasError: true, customerCareNumber, fallbackErrorTitle, fallbackErrorMessage }
    }

    componentDidCatch(error, info) {
        raygun.helpers.agent('send', { error, tags: ['Uncaught exception at ErrorBoundary'], customData: info })
    }

    render() {
        // TODO: Use yos ErrorBoundary component https://git.yoox.net/projects/YOS/repos/yos/browse/packages/components/error-page/src/ErrorBoundary/ErrorBoundary.js?at=1d398ba9c8fbc5c9080187855d68383a3e92dd66
        const { customerCareNumber, fallbackErrorTitle, fallbackErrorMessage, hasError } = this.state
        const { messages } = this.props
        if (hasError) {
            return (
                <SimpleErrorPage
                    displayMessage={messages?.errorBoundary?.title?.() || fallbackErrorTitle}
                    actionLabel={messages?.errorBoundary?.message?.({ customerCareNumber }) || fallbackErrorMessage}
                    className={bem('checkout')}
                />
            )
        }
        return this.props.children
    }
}
